<template>
  <div class="sld_order_list">
    <MemberTitle :memberTitle="L['发布询价']"></MemberTitle>
    <div class="warp1">
      <div class="dital1">{{ L['发布询价'] }}</div>
      <div class="dital">{{ L['询价详情'] }}</div>
      <div class="center">
        <div class="center_box" style="width: 330px">
          <div style="width: 110px; padding-left: 17px;font-size: 14px;">{{ L['报价截止时间'] }}</div>
          <el-date-picker
            v-model="input"
            class="opop1"
            type="date"
            :placeholder="L['选择日期']"
            @change="tinemm"
            :disabled-date="disabledDate"
          ></el-date-picker>
          <span class="cored1">*</span>
        </div>

        <div class="center_box" style="width: 320px">
          <div class="yy" style="width: 100px">{{ L['交货时间'] }}</div>
          <el-date-picker
            v-model="deadlineTime"
            class="opop"
            type="date"
            :placeholder="L['选择日期']"
            :disabled-date="disabledDate1"
            @change="tinemm1"
          ></el-date-picker>
          <span class="cored1">*</span>
        </div>

        <div class="center_box">
          <div class="yy">{{ L['品名'] }}</div>
          <span class="cored1">*</span>
          <el-input
            v-model="inquiryGoodsName"
            class="imm"
            :placeholder="L['请输入内容']"
          ></el-input>
        </div>
        <div class="center_box">
          <div class="yy">{{ L['规格'] }}</div>
          <span class="cored1">*</span>
          <el-input
            v-model="inquirySpec"
            class="imm"
            :placeholder="L['请输入内容']"
          ></el-input>
        </div>
        <div class="center_box">
          <div class="yy">{{ L['单位目标价'] }}</div>
          <span class="cored1">*</span>
          <el-input
            v-model="targetPrice"
            class="imm"
            oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
            :placeholder="L['请输入内容']"
          ></el-input>
        </div>
        <div class="center_box">
          <div class="yy">{{ L['采购量'] }}</div>
          <el-input
            v-model="purchaseNumber"
            oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
            class="imm"
            :placeholder="L['请输入采购数量']"
          ></el-input>
          <span class="cored1">*</span>
        </div>
      </div>

      <div class="textarea1">
        <div class="trt">{{ L['描述'] }}</div>
        <el-input
          type="textarea"
          v-model="inquiryDesc"
          :placeholder="L['请输入内容']"
        ></el-input>
        <span class="cored1">*</span>
      </div>
      <div class="center_box" style="float: left; width: 31.5%">
        <div class="yy" style="width: 107px">{{ L['发货港口'] }}</div>
        <el-select v-model="portId" :placeholder="L['请选择']">
          <el-option
            v-for="item in arry"
            :key="item.portId"
            :label="item.portName"
            :value="item.portId"
          >
          </el-option>
          <option value=""></option>
        </el-select>
        <span class="cored">*</span>
      </div>
      <div class="center_box">
        <div class="yy" style="width: 150px">{{ L['收货国家'] }}</div>
        <el-input
          v-model="receiveCountry"
          class="imm"
          :placeholder="L['请输入内容']"
        ></el-input>
        <span class="cored">*</span>
      </div>
      <div class="Image" style="clear: both; margin-top: 25px">
        <div class="jip">{{ L['图片'] }}</div>
        <span class="cored2">*</span>
        <!-- <div class="typeImage">
          <input class="uiop" type="file" id="image" @change="getImage" />
          <img
            :src="item"
            v-for="(item, index) in Oimage"
            class="bgc1"
            :key="index"
            alt=""
          />
          <label for="image">
            <div class="bgc">+</div>
          </label>
        </div> -->
        <!-- 组件上传的方式 start-->
        <div class="upload">
          <el-upload
            :action="uploadImgUrl"
            list-type="picture-card"
            :on-remove="handleRemove"
            :on-preview="handlePictureCardPreview"
            limit="5"
            :data="upload_data"
            name="file"
            :on-success="uploadImg"
            :on-exceed="exceedHandle"
            id="elUpload"
          >
            <template #default>
              <i class="el-icon-plus"></i>
            </template>
          </el-upload>

          <el-dialog
            v-model="dialogVisible"
            width="70%"
            lock-sroll="false"
            top="10vh"
          >
            <div
              style="overflow: auto; width: 100%; display: flex; justify-content: center;"
            >
              <img
                w-full
                :src="dialogImageUrl"
                alt="Preview Image"
                style="max-height: 700px;"
              />
            </div>
          </el-dialog>
        </div>
        <!-- 组件上传的方式 end-->
      </div>

      <div class="hui">
        <label for="image1">
          <div class="cer fj">{{ L['+添加文件'] }}</div>
        </label>
        <input class="uiop" type="file" id="image1" @change="fileword" />

        <div class="csadr" v-for="(item, index1) in file2" :key="index1">
          <div class="cer" style="padding-left: -10px">
            文件{{ index1 + 1 }}:
          </div>
          <div class="oiu">
            <el-input :value="item" :placeholder="item" disabled></el-input>
          </div>
        </div>
      </div>

      <div class="dital">{{ L['联系方式'] }}</div>
      <div class="center">
        <div class="center_box">
          <div class="yy" style="width: 120px">{{ L['手机号'] }}</div>
          <el-input
            v-model="contactPhone"
            :disabled="true"
            class="imm"
            :placeholder="L['请输入内容']"
          ></el-input>
          <span class="cored">*</span>
        </div>
        <!-- <div class="center_box">
          <div class="yy" style="width: 150px">{{ L['短信验证码'] }}</div>
          <el-input v-model="smsCode" :placeholder="L['请输入内容']"></el-input>
          <span class="cored">*</span>
          <div class="code" v-if="dingzhi == 1" @click="scodeimage">
            {{ L['发起短信验证码'] }}
          </div>
          <div class="code" v-if="dingzhi == 2">{{ countTime }}S</div>
        </div> -->
        <div class="center_box">
          <div class="yy" style="width: 150px">{{ L['联系人姓名'] }}</div>
          <el-input
            :disabled="true"
            v-model="contactName"
            class="imm"
            :placeholder="L['请输入内容']"
          ></el-input>
          <span class="cored">*</span>
        </div>
        <div class="center_box">
          <div class="yy" style="width: 150px">{{ L['公司名称'] }}</div>
          <el-input
            :disabled="true"
            v-model="companyName"
            class="imm"
            :placeholder="L['请输入内容']"
          ></el-input>
          <span class="cored">*</span>
        </div>
      </div>

      <div class="center" v-if="isAppointFactory == 2">
        <div class="center_box">
          <div class="yy" style="width: 150px">工厂名称：</div>
          <el-input
            v-model="ccname"
            class="imm"
            disabled="true"
            placeholder="请输入内容"
          ></el-input>
          <span class="cored">*</span>
        </div>
        <!-- <div class="center_box">
          <div class="yy" style="width: 150px">国家：</div>
          <el-input  v-model="receiveCountry"  class="imm"  placeholder="请输入内容" ></el-input>
          <span class="cored">*</span>
        </div> -->
      </div>
      <div class="ooo">
        <div>
          {{ L['是否发送到抢单大厅'] }}
          <el-radio-group v-model="isSendHall">
            <el-radio :label="1">{{ L['是'] }}</el-radio>
            <el-radio :label="2">{{ L['否'] }}</el-radio>
          </el-radio-group>
        </div>
      </div>

      <div class="submit">
        <el-button type="danger" class="btnnn" @click="submit"
          >{{ L['发布询价'] }}</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter, useRoute } from 'vue-router' //引入路由
import MemberTitle from '../../../components/MemberTitle'
import { reactive, ref, getCurrentInstance, onMounted, toRaw } from 'vue'
import { ElMessage } from 'element-plus'
import { apiUrl } from '../../../utils/config'

export default {
  components: {
    MemberTitle
  },
  setup () {
    const errr = ref('')
    const endtime1 = ref('')
    const route = useRoute()
    const router = useRouter()
    const inquiryGoodsName = ref('') //品名
    const { proxy } = getCurrentInstance()
    const L = proxy.$getCurLanguage();
    const inquirySpec = ref('') //规格
    const purchaseNumber = ref('') //采购量
    const targetPrice = ref('') //目标价
    const input = ref('') //交货时
    const inquiryDesc = ref('') //描述
    const textarea = ref('')
    const radio = ref('')
    const portId = ref('') //发布港口
    const isSendHall = ref('')
    const nnme = ref('')
    const ccname = ref(route.query.name)
    const endtime = ref('')
    const contactName = ref('') //联系人姓名
    const companyName = ref('') //公司名称
    const contactPhone = ref('') //手机号
    const receiveCountry = ref('') //收货国家
    const companyName1 = ref('')
    const deadlineTime = ref('') //报价截至时间
    const Oimage = ref([])
    const Oimage1 = ref([]) //图片要传的参数
    const file1 = ref([])
    const file2 = ref([])
    const smsCode = ref('') //验证码
    const dingzhi = ref(1)
    const dialogImageUrl = ref('') //图片预览图片地址
    const obj_disab = ref({})
    const countTime = ref(60)
    const arry = ref([])
    const isAppointFactory = ref(route.query.isAppointFactory)
    const upload_data = reactive({
      source: 'goods'
    })
    const dialogVisible = ref(false) //图片预览弹框是否显示
    const upLoadFile = reactive({ data: [] }) //用于传给后端的文件列表
    const submit = () => {
      //提交表单
      let params = {}
      let date = new Date(input.value)
      console.log(date)
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      let d = date.getDate()
      d = d < 10 ? '0' + d : d
      let time = y + '-' + m + '-' + d
      let date1 = new Date(deadlineTime.value)
      console.log(date1)
      let y1 = date1.getFullYear()
      let m1 = date1.getMonth() + 1
      m1 = m1 < 10 ? '0' + m1 : m1
      let d1 = date1.getDate()
      d1 = d1 < 10 ? '0' + d1 : d1
      let time1 = y1 + '-' + m1 + '-' + d1
      params.portId = portId.value //发布港口
      params.inquirySpec = inquirySpec.value //规格
      params.purchaseNumber = purchaseNumber.value //采购量
      params.targetPrice = targetPrice.value //目标价
      params.deliveryTime = time1 //交货时间
      params.inquiryDesc = inquiryDesc.value // 描述
      params.deadlineTime = time //报价截至时间
      params.companyName = companyName.value
      params.receiveCountry = receiveCountry.value //收货国家
      params.smsCode = smsCode.value //验证码
      params.inquiryGoodsName = inquiryGoodsName.value //品名
      params.contactName = contactName.value //联系人姓名
      params.contactPhone = contactPhone.value //联系人手机号
      // params.inquiryGoodsImg = Oimage1.value.toString() //处理图片
      params.inquiryGoodsImg = upLoadFile.data.join(',') //处理图片
      params.enclosure = file1.value.toString() //处理文件
      params.isAppointFactory = route.query.isAppointFactory == 2 ? '1' : '2'
      if (route.query.isAppointFactory == 2) {
        params.factoryName = ccname.value //处理文件
      }
      params.isSendHall = isSendHall.value
      let checkMobile = proxy.$checkMobile(contactPhone.value)
      if (checkMobile != true) {
        ElMessage('请输入正确的手机号')
        return false
      } else if (
        !(
          contactName.value &&
          contactPhone.value &&
          receiveCountry.value &&
          // smsCode.value &&
          portId.value &&
          deadlineTime.value &&
          inquiryDesc.value &&
          purchaseNumber.value &&
          upLoadFile.data[0] &&
          inquiryGoodsName.value &&
          inquirySpec.value &&
          targetPrice.value
        )
      ) {
        console.log(params)
        ElMessage('请填写完整信息')
      } else {
        proxy
          .$post('/v3/goods/front/goods/inquiry/publish', params)
          .then(res => {
            if (res.state == 200) {
              router.push({ path: `/member/xuanjiada/xuenjiajilu` })
              console.log(router)
            } else {
              ElMessage(res.msg)
            }
          })
      }
    }
    const oneList = () => {
      let params = {}
      proxy.$get('v3/member/front/memberDeliverPort/list', params).then(res => {
        console.log('res.data.list------', res.data.list)
        arry.value = res.data.list
        // console.log(arry.value)
      })
    }
    // const getImage = e => {
    //   console.log('eeeee--1111', e)
    //   proxy
    //     .$post(
    //       '/v3/oss/common/upload',
    //       { source: 'goods', file: e.target.files[0] },
    //       'form'
    //     )
    //     .then(res => {
    //       if (res.state == 200) {
    //         Oimage.value.push(res.data.url)
    //         Oimage1.value.push(res.data.path)
    //       } else {
    //         ElMessage(res.msg)
    //       }
    //     })
    // }

    // const uploadImgUrl = e => {
    //   proxy
    //     .$post(
    //       '/v3/oss/common/upload',
    //       { source: 'goods', file: e.target.files[0] },
    //       'form'
    //     )
    //     .then(res => {
    //       if (res.state == 200) {
    //         Oimage.value.push(res.data.url)
    //         Oimage1.value.push(res.data.path)
    //       } else {
    //         ElMessage(res.msg)
    //       }
    //     })
    // }

    // 组件上传的方式
    const uploadImgUrl = apiUrl + '/v3/oss/common/upload' //图片上传路径
    console.log('uploadImgUrl------', uploadImgUrl)

    //图片预览
    const handlePictureCardPreview = response => {
      let imageUrl = toRaw(response)
      dialogVisible.value = true
      dialogImageUrl.value = imageUrl.response.data.url
      console.log(imageUrl.response.data.url)
    }

    //上传图片
    const uploadImg = response => {
      console.log('response------', response)
      if (response.state == 200) {
        upLoadFile.data.push(response.data.path)
        console.log('upLoadFile.data------', upLoadFile.data)
      }
      if (upLoadFile.data.length == 5) {
        document.getElementById('elUpload').children[1].style.display = 'none'
      }
    }
    const handleRemove = file => {
      if (file.status == 'success') {
        upLoadFile.data = upLoadFile.data.filter(
          item => item != file.response.data.path
        )
      }
      if (upLoadFile.data.length < 5) {
        document.getElementById('elUpload').children[1].style.display =
          'inline-block'
      }
    }

    //上传图片，图片超出限制
    const exceedHandle = () => {
      ElMessage('最多上传5张！')
    }
    const tress_1 = () => {
      proxy.$get('/v3/member/front/memberAttest/detailed').then(res => {
        obj_disab.value = res.data
        companyName.value = res.data.companyName
        contactPhone.value = res.data.memberMobile
        contactName.value = res.data.memberTrueName
      })
    }
    const tinemm = e => {
      endtime1.value = e.getTime() + 24 * 60 * 60 * 1000
    }
    const tinemm1 = e => {
      console.log(e)
      if (input.value == '') {
        deadlineTime.value = ''
        ElMessage('请先选择报价截止时间')
      }
    }
    const scodeimage = () => {
      let params = {}
      params.mobile = contactPhone.value
      params.type = 'wxAuth'
      proxy.$get('/v3/msg/front/commons/smsCode', params).then(res => {
        console.log(res)
        if (res.state == 200) {
          let secInterval = setInterval(() => {
            if (countTime.value == 0) {
              dingzhi.value = 1
              clearInterval(secInterval)
            } else {
              countTime.value--
              dingzhi.value = 2
            }
            // console.log(countTime.value)
          }, 1000)
        } else {
          ElMessage(res.msg)
        }
      })
    }
    const disabledDate = time => {
      return time.getTime() < endtime.value
    }
    const disabledDate1 = time => {
      return time.getTime() < endtime1.value
    }
    const fileword = e => {
      if (e.target.files[0]) {
        proxy
          .$post(
            '/v3/oss/common/upload',
            { source: 'files', file: e.target.files[0] },
            'form'
          )
          .then(res => {
            console.log('upload---res---111', res)
            if (res.state == 200) {
              file1.value.push(res.data.path)
              file2.value.push(res.data.fileName)
            } else {
              ElMessage(res.msg)
            }
          })
      } else {
        ElMessage('文件重复请重新上传')
      }
    }

    onMounted(() => {
      endtime.value = new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
      oneList()
      tress_1()

      //获取询价单
      // console.log(route.query.isAppointFactory==2)
      // if (route.query.isAppointFactory == 2||route.query.isAppointFactory == '2') {
      //   isAppointFactory.value == 1;
      //   console.log(1111)
      // } else {
      //   isAppointFactory.value == 2;
      // }
      // console.log(isAppointFactory.value)
      // contactName.value = route.query.name;
    })

    return {
      L,
      input,
      textarea,
      nnme,
      radio,
      inquiryGoodsName,
      purchaseNumber,
      inquirySpec,
      targetPrice,
      inquiryDesc,
      contactName,
      contactPhone,
      receiveCountry,
      deadlineTime,
      companyName,
      isSendHall,
      disabledDate,
      disabledDate1,
      // getImage,
      uploadImgUrl,
      handlePictureCardPreview,
      uploadImg,
      upLoadFile,
      handleRemove,
      exceedHandle,
      upload_data,
      Oimage,
      Oimage1,
      fileword,
      file1,
      file2,
      companyName1,
      ccname,
      scodeimage,
      tinemm,
      smsCode,
      portId,
      dingzhi,
      countTime,
      submit,
      tinemm1,
      tress_1,
      oneList,
      endtime,
      endtime1,
      arry,
      isAppointFactory,
      errr,
      obj_disab,
      dialogImageUrl,
      dialogVisible
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../style/fabuxuenjia.scss';
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none; // 隐藏选中标识的绿色勾勾
}
// ::v-deep .el-icon-zoom-in:before {
//   content: '';  // 隐藏预览放大icon
// }
::v-deep .el-upload-list__item .el-icon-close-tip {
  opacity: 0; // 隐藏按delete可删除
}
</style>
